import { Container, VStack, Alert, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { isAdmin, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  if (!isAuthenticated) {
    navigate('/login')
    return null
  }

  if (!isAdmin) {
    return (
      <Container maxW="container.md" py={16}>
        <VStack gap={4}>
          <Alert.Root status="error" borderRadius="md">
            <Alert.Indicator />
            Access denied. Admin privileges are required to view this page.
          </Alert.Root>
          <Button colorPalette="brand" onClick={() => navigate('/dashboard')}>
            Return to Dashboard
          </Button>
        </VStack>
      </Container>
    );
  }

  return <>{children}</>
}
